module.exports = __webpack_public_path__ + "media/images/icon__arrow-right@2x-9c523b500451541b786fb7b1d177adfb.png";